import { PublicStackParamList } from "@app/navigationApp/types"
import Button from "@app/sharedComponents/Button/Button"
import { ThemedText, ThemedView } from "@app/theme"
import { ThemedTouchableOpacity } from "@app/theme/Components"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { useEffect, useState } from "react"
import { Dimensions, FlatList, Image , Pressable } from "react-native"

const data = [
    {
        id: "1",
        image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_first_image.png',
        text: "Unlock cash from mutual fund \n savings in 5 mins",
    },
    {
        id: "2",
        image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_second_image.png',
        text: "Withdraw only what you need,\n and repay flexibly",
    },
    {
        id: "3",
        image: 'https://volt-images.s3.ap-south-1.amazonaws.com/intro_third_image.png',
        text: "Let your savings grow",
    },
]



const Indicators = ({ activeIndex }: { activeIndex: number }) => {
    return (
        <ThemedView mt="2xl" flexDirection="row">
            {[new Array(3).fill(0).map((_, i) => (
                <ThemedView mr={i < 2 ? 'lg' : undefined} height={6} width={6} borderRadius="full" backgroundColor={activeIndex === i ? "bg-action-primary" : "border-error"} />
            ))]}
        </ThemedView>
    )
}

type ScreenProps = NativeStackScreenProps<PublicStackParamList , 'GET_STARTED'>

const GetStarted = ({navigation} : ScreenProps) => {
    const { width } = Dimensions.get('screen')

    const [activeIndex, setActiveIndex] = useState<number>(0);

    const viewabilityConfig = {
        itemVisiblePercentThreshold: 50,
    };

    useEffect(() => {
        AsyncStorage.setItem('first_time', 'true')
    }, [])


    return (

        <ThemedView bg="bg-surface-primary" justifyContent="space-between" padding="lg" flex={1}>
            <ThemedView alignItems="center" >
                <ThemedView paddingVertical="2xl" mb="2xl">
                    <Image
                        style={{ width: 64, height: 24 }}
                        source={{ uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.png' }}
                    />
                </ThemedView>
                <FlatList
                    onScroll={(event) => {
                        const totalWidth = event.nativeEvent.layoutMeasurement.width
                        const xPosition = event.nativeEvent.contentOffset.x
                        const newIndex = Math.round(xPosition / totalWidth)
                        if (newIndex !== activeIndex) {
                            setActiveIndex(newIndex)
                        }
                    }}
                    viewabilityConfig={viewabilityConfig}
                    showsHorizontalScrollIndicator={false} horizontal pagingEnabled data={data} keyExtractor={item => item?.id} renderItem={({ item }) => {
                        return (
                            <ThemedView justifyContent="center">
                                <Image resizeMode="contain" source={{ uri: item?.image }} style={{ height: width * 0.9, width: width * 0.9 }} />
                                <ThemedText marginVertical="xl" fontWeight="700" textAlign="center" variant="h4s">{item?.text}</ThemedText>
                            </ThemedView>
                        )
                    }} />
                <Indicators activeIndex={activeIndex} />
            </ThemedView>
            <Button
                size="LG"
                label={'Get Started'}
                type={'SOLID'}
                disabled={false}
                handlePress={() => {
                    navigation.replace('LOGIN_MOBILE_NUMBER_SCREEN')
                }}
                eventName='GET_STARTED'
            />
        </ThemedView>
    )
}

export default GetStarted